export default "__VITE_ASSET__76e6484c__"